import { render, staticRenderFns } from "./home_footer.vue?vue&type=template&id=0948d2c2&scoped=true"
import script from "./home_footer.vue?vue&type=script&lang=js"
export * from "./home_footer.vue?vue&type=script&lang=js"
import style0 from "./home_footer.vue?vue&type=style&index=0&id=0948d2c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0948d2c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0948d2c2')) {
      api.createRecord('0948d2c2', component.options)
    } else {
      api.reload('0948d2c2', component.options)
    }
    module.hot.accept("./home_footer.vue?vue&type=template&id=0948d2c2&scoped=true", function () {
      api.rerender('0948d2c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobilePage/home_footer.vue"
export default component.exports